import { RouteConfig } from 'vue-router'
import { requireAuthAndLocation } from '../../auth'

const Coupons = () => import('@/pmd/pages/payments/v2/Coupons.vue')
const CreateCouponsApp = () => import('@/pmd/pages/payments/v2/CreateCoupons.vue')

export const CouponsRoute: RouteConfig[] = [
  {
    path: 'payments/coupons',
    name: 'coupons',
    component: Coupons,
    beforeEnter: requireAuthAndLocation,
    children: [],
  },
  {
    path: 'payments/coupons/create',
    name: 'create-coupon',
    component: CreateCouponsApp,
    beforeEnter: requireAuthAndLocation,
    children: [],
  },
  {
    path: 'payments/coupons/edit/:id',
    name: 'edit-coupon',
    component: CreateCouponsApp,
    beforeEnter: requireAuthAndLocation,
    children: [],
  },
]
